import { fetchFiles } from "actions/file";
import { FILES_PAGE_SIZE } from "constants/util";
import RequireData from "hooks/RequireData";
import SagePaginationButton from "kit/SagePaginationButton";
import React from "react";
import filesSelector from "selectors/files";
import filesStatusSelector from "selectors/filesStatus";
import FileListRow from "./FileListRow";
import styles from "./FileListPage.module.scss";

interface Props {
    page: number;
    increment: () => void;
    decrement: () => void;
}

const FileListPage: React.FC<Props> = ({ increment, decrement, page }) => {
    const [files, status] = RequireData(
        filesSelector(page),
        filesStatusSelector(page),
        fetchFiles(page)
    );

    if (status === "error") {
        return (
            <div>
                <p className="text-danger">
                    Error occurred. Please reload to try again.
                </p>
            </div>
        );
    }

    if (status === "loading" || files === undefined) {
        return (
            <div>
                <p>Loading...</p>
            </div>
        );
    }

    return (
        <div className="row align-items-start">
            <div className="col">
                {files.map((file) => (
                    <FileListRow file={file} key={file.id} />
                ))}
                <SagePaginationButton
                    className={styles.buttonGroup}
                    incrementPage={increment}
                    decrementPage={decrement}
                    page={page}
                    canGoNext={files && files.length >= FILES_PAGE_SIZE}
                />
            </div>
        </div>
    );
};

export default FileListPage;
